module.exports = __webpack_public_path__ + "static/media/social_media_whastsapp.b8abe650.svg";